import { I18n } from '@calendly/i18n'
import { isEqual } from 'lodash-es'

import { formatTime, parseTime } from 'services/time_format'

const parseInterval = (interval) => {
  const from = parseTime(interval.from)
  const to = parseTime(interval.to)

  if (to.format('HH:mm') === '00:00') {
    to.add(1, 'day')
  }

  return { from, to }
}

const getError = (interval) => {
  const { from, to } = parseInterval(interval)

  if (!from.isValid()) return 'invalid_time_from'
  if (!to.isValid()) return 'invalid_time_to'
  if (from.isSameOrAfter(to)) return 'invalid_duration'

  return undefined
}

const isOverlapping = (a, b) => {
  const x = parseInterval(a)
  const y = parseInterval(b)

  const xFromInsideY = x.from.isSameOrAfter(y.from) && x.from.isBefore(y.to)
  const xToInsideY = x.to.isAfter(y.from) && x.to.isSameOrBefore(y.to)
  const yInsideX = x.from.isSameOrBefore(y.from) && x.to.isSameOrAfter(y.to)

  return xFromInsideY || xToInsideY || yInsideX
}

export const validateIntervals = (intervals) => {
  const validatedIntervals = intervals.map((interval) => ({
    ...interval,
    error: getError(interval)
  }))

  validatedIntervals.forEach((a, index) => {
    if (a.error && a.error !== 'overlap') return

    const otherIntervals = validatedIntervals.slice(index + 1)

    otherIntervals.forEach((b) => {
      if (b.error && b.error !== 'overlap') return

      if (isOverlapping(a, b)) {
        a.error = 'overlap'
        b.error = 'overlap'
      }
    })
  })

  return validatedIntervals
}

const sortByStartTime = (a, b) => (parseTime(a.from) < parseTime(b.from) ? -1 : 1)

export const validateAndSortIntervals = (intervals) => {
  const validated = validateIntervals(intervals)

  if (validated.every(({ error }) => !error)) {
    validated.sort(sortByStartTime)
  }

  return validated
}

export const checkIntervalsSorted = (intervals, sortedIntervals) => {
  const intervalsStartTimes = intervals.map(({ from }) => from)
  const sortedIntervalsStartTimes = sortedIntervals.map(({ from }) => from)

  return !isEqual(intervalsStartTimes, sortedIntervalsStartTimes)
}

export const generateSortedIntervalsAnnouncement = (intervals, timeNotation) => {
  const sortedAnnouncement = intervals.map(({ from, to }) => {
    const intervalStart = parseTime(from)
    const intervalEnd = parseTime(to)
    const formattedIntervalStart = formatTime(intervalStart, timeNotation)
    const formattedIntervalEnd = formatTime(intervalEnd, timeNotation)

    return `${I18n.t('publisher.event_types.availability.from')}
    ${formattedIntervalStart} ${I18n.t('publisher.event_types.availability.to')} ${formattedIntervalEnd}`
  })

  return sortedAnnouncement.join(', ')
}
